import SubNews from 'app/components/topNewsModule/subNews/SubNews';
import React from 'react';
import SwipeableViewsStepper from 'app/components/swipeableViews/SwipeableViewsStepper';
import { Container, SubNewsWrapper } from 'app/components/topNewsModule/subNews/subNewsStyles';
import createRenderedViewsFromArray from 'app/components/swipeableViews/createRenderedViewsFromArray';
import { DistrictMainPageModuleType, useDistrictMainPageTracking } from 'app/components/district/news/DistrictMainPageTracking';
export default function SwipeableNewsList(_ref) {
  let {
    newsList,
    newsPerView,
    updateTrackingData
  } = _ref;
  const {
    trackClickedItemPage
  } = useDistrictMainPageTracking();
  const createListElement = (data, index) => /*#__PURE__*/React.createElement(SubNews, {
    key: "sub-news-".concat(newsPerView, "-").concat(index),
    data: data,
    "data-sentry-element": "SubNews",
    "data-sentry-component": "createListElement",
    "data-sentry-source-file": "SwipeableNewsList.tsx"
  });
  const createFillerElement = index => /*#__PURE__*/React.createElement(SubNewsWrapper, {
    key: "news-filler-".concat(newsPerView, "-").concat(index),
    "data-sentry-element": "SubNewsWrapper",
    "data-sentry-component": "createFillerElement",
    "data-sentry-source-file": "SwipeableNewsList.tsx"
  });
  const views = createRenderedViewsFromArray(newsList, createListElement, createFillerElement, newsPerView);
  const handleOnClick = pageIndex => {
    trackClickedItemPage(DistrictMainPageModuleType.TOPNEWS, pageIndex);
  };
  return /*#__PURE__*/React.createElement(SwipeableViewsStepper, {
    callback: updateTrackingData,
    views: views,
    viewRender: _ref2 => {
      let {
        index
      } = _ref2;
      return /*#__PURE__*/React.createElement(Container, {
        onClick: () => handleOnClick(index),
        key: "news-".concat(newsPerView, "-").concat(index)
      }, views[index]);
    },
    "data-sentry-element": "SwipeableViewsStepper",
    "data-sentry-component": "SwipeableNewsList",
    "data-sentry-source-file": "SwipeableNewsList.tsx"
  });
}